import { render, staticRenderFns } from "./OfficialHolidaysPlanForm.vue?vue&type=template&id=2a51d61b&scoped=true&"
import script from "./OfficialHolidaysPlanForm.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51d61b",
  null
  
)

export default component.exports